import { Fragment } from 'react';
import styled from 'styled-components';
import cross from '../../../assets/images/white_error_cross.svg';

interface IProps {
  messages: ReadonlyArray<string>;
  bgColor?: string;
  textColor?: string;
  fontSize?: number;
}

const ValidationErrors: React.FC<IProps> = ({ messages, bgColor = '#F79F79', textColor = 'white', fontSize = 16 }) => {
  const validation = messages.map((message, i) => <Item key={i}>{message}</Item>);
  return (
    <Fragment>
      <ErrorBox data-selector="validation-errors" $bgColor={bgColor} $textColor={textColor} $fontSize={fontSize}>
        <List>{validation}</List>
      </ErrorBox>
    </Fragment>
  );
};

const ErrorBox = styled.div<{
  $textColor: string;
  $bgColor?: string;
  $fontSize: number;
}>`
  color: ${({ $textColor }) => $textColor};
  border-radius: 5px 5px 5px 5px;
  background-color: ${({ $bgColor }) => $bgColor};
  font-size: ${({ $fontSize }) => $fontSize}px;
  margin: 3px;
  padding-left: 5px;
  padding-right: 5px;
`;

const List = styled.ul`
  padding-inline-start: 0px;
  margin-block-start: 1em;
  margin-block-end: 0;
  padding-top: 5px;
  padding-bottom: 5px;
`;

const Item = styled.li`
  background: url(${cross}) no-repeat left center;
  padding: 3px 0px 3px 30px;
  /* reset styles (optional): */
  list-style: none;
  margin: 0;
`;

export default ValidationErrors;
